import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["emailRow"];

  addEmail() {
    const newRow = document.createElement("div");
    newRow.className = "flex gap-2 items-center";
    newRow.setAttribute("data-business-emails-target", "emailRow");
    
    newRow.innerHTML = `
      <input type="email" name="organization[business_emails][]" required class="flex-1 px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-700 dark:bg-gray-900 dark:text-white" placeholder="support@example.com" />
      <button type="button" class="px-3 py-2 text-sm font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 dark:bg-red-900/20 dark:text-red-400 dark:hover:bg-red-900/30" data-action="click->business-emails#removeEmail">
        Remove
      </button>
    `;
    
    // Find the list container
    const list = this.element.querySelector("#business-emails-list");
    if (list) {
      if (this.emailRowTargets.length > 0) {
        this.emailRowTargets[this.emailRowTargets.length - 1].after(newRow);
      } else {
        list.appendChild(newRow);
      }
    } else {
      // Fallback: append to controller element
      this.element.appendChild(newRow);
    }
    
    // Focus on the new input
    const input = newRow.querySelector("input[type='email']");
    if (input) {
      input.focus();
    }
  }

  removeEmail(event) {
    const row = event.currentTarget.closest("[data-business-emails-target='emailRow']");
    if (this.emailRowTargets.length > 1) {
      row.remove();
    } else {
      // If it's the last one, just clear the input
      const input = row.querySelector("input[type='email']");
      if (input) {
        input.value = "";
      }
    }
  }
}
